import React from 'react';

const MenuFilters = ({ selectedCategory, setSelectedCategory, selectedDietary, setSelectedDietary }) => {
  const categories = [
    { id: 'all', label: 'All Items' },
    { id: 'breakfast', label: 'Breakfast & Brunch' },
    { id: 'starters', label: 'Starters' },
    { id: 'mains', label: 'Mains' },
    { id: 'burgers', label: 'Burgers & Sandwiches' },
    { id: 'coffee', label: 'Coffee & Tea' },
    { id: 'beverages', label: 'Beverages' },
    { id: 'desserts', label: 'Desserts' },
  ];

  const dietaryOptions = [
    { id: 'all', label: 'All Dietary' },
    { id: 'vegetarian', label: 'Vegetarian' },
    { id: 'vegan', label: 'Vegan' },
    { id: 'gluten-free', label: 'Gluten-Free' },
    { id: 'dairy-free', label: 'Dairy-Free' },
  ];

  return (
    <div data-component-path="client/src/components/MenuFilters.jsx" data-component-line="26:5" data-component-id="client/src/components/MenuFilters.jsx:26:5" className="mb-12">
      <div data-component-path="client/src/components/MenuFilters.jsx" data-component-line="27:7" data-component-id="client/src/components/MenuFilters.jsx:27:7" className="mb-6">
        <h3 data-component-path="client/src/components/MenuFilters.jsx" data-component-line="28:9" data-component-id="client/src/components/MenuFilters.jsx:28:9" className="text-lg font-semibold text-charcoal mb-3">Categories</h3>
        <div data-component-path="client/src/components/MenuFilters.jsx" data-component-line="29:9" data-component-id="client/src/components/MenuFilters.jsx:29:9" className="flex flex-wrap gap-3">
          {categories.map(category => (
            <button data-component-path="client/src/components/MenuFilters.jsx" data-component-line="31:13" data-component-id="client/src/components/MenuFilters.jsx:31:13" 
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-5 py-2.5 rounded-full transition-all duration-200 font-medium ${
                selectedCategory === category.id
                  ? 'bg-copper text-white shadow-md'
                  : 'bg-white text-charcoal border border-gray-300 hover:border-copper hover:text-copper'
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>
      </div>

      <div data-component-path="client/src/components/MenuFilters.jsx" data-component-line="47:7" data-component-id="client/src/components/MenuFilters.jsx:47:7">
        <h3 data-component-path="client/src/components/MenuFilters.jsx" data-component-line="48:9" data-component-id="client/src/components/MenuFilters.jsx:48:9" className="text-lg font-semibold text-charcoal mb-3">Dietary Options</h3>
        <div data-component-path="client/src/components/MenuFilters.jsx" data-component-line="49:9" data-component-id="client/src/components/MenuFilters.jsx:49:9" className="flex flex-wrap gap-3">
          {dietaryOptions.map(option => (
            <button data-component-path="client/src/components/MenuFilters.jsx" data-component-line="51:13" data-component-id="client/src/components/MenuFilters.jsx:51:13" 
              key={option.id}
              onClick={() => setSelectedDietary(option.id)}
              className={`px-5 py-2.5 rounded-full transition-all duration-200 font-medium ${
                selectedDietary === option.id
                  ? 'bg-sage text-white shadow-md'
                  : 'bg-white text-charcoal border border-gray-300 hover:border-sage hover:text-sage'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenuFilters;